module.exports = __webpack_public_path__ + "img/p16.9357846e.svg";